import React from 'react';
import { Modal, ModalBody, ModalHeader, Button } from 'reactstrap';
import ReactPlayer from 'react-player';

const YouTubeModal = ({ isOpen, toggle, videoUrl, title }) => {

  return (
    <Modal style={{width:"95%"}} isOpen={isOpen} toggle={toggle} size="lg" centered className="youtube-video-modal border-0">
      <ModalBody className="p-0 position-relative" style={{ borderRadius: '12px', overflow: 'hidden' }}>
        <button 
          type="button" 
          onClick={toggle} 
          className="close-modal-btn"
          style={{ 
            position: 'absolute', 
            top: '15px', 
            right: '15px', 
            zIndex: 100, 
            background: 'rgba(0,0,0,0.5)', 
            color: '#fff', 
            border: 'none', 
            borderRadius: '50%', 
            width: '32px', 
            height: '32px', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            cursor: 'pointer',
            fontSize: '20px',
            transition: 'background 0.3s'
          }}
          onMouseOver={(e) => e.currentTarget.style.background = 'rgba(0,0,0,0.8)'}
          onMouseOut={(e) => e.currentTarget.style.background = 'rgba(0,0,0,0.5)'}
        >
          &times;
        </button>
        <div className="p-3 bg-white border-bottom">
          <span className="text-dark font-weight-bold" style={{ fontSize: '1.1rem' }}>{title || 'Video Update'}</span>
        </div>
          <div className="p-3">
          <div 
            className="player-wrapper" 
            style={{ 
              position: 'relative', 
              paddingTop: '56.25%', 
              backgroundColor: '#000',
              cursor: 'pointer',
              borderRadius: '8px',
              overflow: 'hidden',
              boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
            }}
          >
            <ReactPlayer
              url={videoUrl}
              width="100%"
              height="100%"
              style={{ position: 'absolute', top: 0, left: 0 }}
              controls={true}
              playing={true}
              light={true} 
            />
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default YouTubeModal;
